import { createElement } from 'react';
import './index.scss';
import classNames from "classnames";
const ColorfulTypography = function ColorfulTypography({ type, text, theme, title, space, bold, underline, children, ...otherProps }) {
    const _otherProps = otherProps || {};
    const typographyClass = [type, theme].filter(_ => !!_).map(_ => `${'au-typography'}-${_}`).join(' ');
    const handleEleTag = (type, title) => {
        if (type === 'title') {
            return title;
        }
        if (type === 'paragraph') {
            return 'p';
        }
        if (type === 'list') {
            return 'ul';
        }
        if (type === 'span') {
            return 'span';
        }
        return 'p';
    };
    const Tag = handleEleTag(type, title);
    const prefixCls = 'au-typography';
    const classString = classNames(prefixCls, typographyClass, {
        [`${prefixCls}-space`]: space,
        [`${prefixCls}-bold`]: bold,
        [`${prefixCls}-underline`]: underline,
    });
    return (createElement(Tag, { className: classString, ..._otherProps }, text || '标题/文本'));
};
ColorfulTypography.displayName = 'ColorfulTypography';
export default ColorfulTypography;
